module.exports = __webpack_public_path__ + "static/media/jumbo_banner_4_mobile.b86c483e.jpg";